module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.filterZones
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Show Panel Serial Numbers"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.columns.panelSerial),
      callback: function($$v) {
        _vm.$set(_vm.columns, "panelSerial", $$v)
      },
      expression: "columns.panelSerial"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Show Billing Due Date"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.columns.billingDueDate),
      callback: function($$v) {
        _vm.$set(_vm.columns, "billingDueDate", $$v)
      },
      expression: "columns.billingDueDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addZoneClick()
      }
    }
  }, [_vm._v("+ Add Zone")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.zones,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Zone Name",
      "width": "300",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gsd_id",
      "label": "Zone ID",
      "sortable": "",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "boro_name",
      "label": "Boro",
      "sortable": "",
      "width": "150"
    }
  }), _vm._v(" "), (_vm.columns.panelSerial) ? _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "Panel Serial",
      "width": "350"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.columns.billingDueDate) ? _c('el-table-column', {
    attrs: {
      "label": "Next Billing",
      "width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.billingDue) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(_vm._s(scope.row.nextBillingAt))])], 1) : _c('div', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v(_vm._s(scope.row.nextBillingAt))])], 1)]
      }
    }], null, false, 2350755131)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.zoneActivate(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Activate")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.zoneEditClick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Edit")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.zoneDialog.title,
      "visible": _vm.zoneDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.zoneDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.zoneDialog.loading),
      expression: "zoneDialog.loading"
    }],
    attrs: {
      "model": _vm.zoneDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zone Name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.zoneDialog.form.name),
      callback: function($$v) {
        _vm.$set(_vm.zoneDialog.form, "name", $$v)
      },
      expression: "zoneDialog.form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zone ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.zoneDialog.form.zoneID),
      callback: function($$v) {
        _vm.$set(_vm.zoneDialog.form, "zoneID", $$v)
      },
      expression: "zoneDialog.form.zoneID"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Boro"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.zoneDialog.form.boro),
      callback: function($$v) {
        _vm.$set(_vm.zoneDialog.form, "boro", $$v)
      },
      expression: "zoneDialog.form.boro"
    }
  }, _vm._l((_vm.boro_options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Next Billing"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Pick a date"
    },
    model: {
      value: (_vm.zoneDialog.form.nextBillingAt),
      callback: function($$v) {
        _vm.$set(_vm.zoneDialog.form, "nextBillingAt", $$v)
      },
      expression: "zoneDialog.form.nextBillingAt"
    }
  })], 1), _vm._v(" "), (_vm.zoneDialog.showPanelID) ? _c('el-form-item', {
    attrs: {
      "label": "Panel ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.zoneDialog.form.deviceID),
      callback: function($$v) {
        _vm.$set(_vm.zoneDialog.form, "deviceID", $$v)
      },
      expression: "zoneDialog.form.deviceID"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.zoneDialogClick()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d70e918"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Zones.vue
// module id = 1387
// module chunks = 1